import Pagination from '@sats-group/ui-lib/react/pagination';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { Layout } from '~/source/ui/layout/layout';
import { Enroll } from './enroll/enroll';
import { MembersEntry } from './members-entry';
import type { Members as Props } from './members.page.types';

export const Members: React.FC<Props> = ({
  enroll,
  layout,
  list,
  pagination,
}) => (
  <Layout {...layout} actions={<Enroll {...enroll} />}>
    <div className="members">
      <div className="members__inner">
        <table>
          <thead>
            <tr>
              {list.header.map(entry => (
                <th key={entry}>
                  <Text size={Text.sizes.small} theme={Text.themes.emphasis}>
                    {entry}
                  </Text>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list.items.map(entry => (
              <MembersEntry {...entry} key={entry.id} />
            ))}
          </tbody>
        </table>
        <div className="members__containment">
          <div className="members__pages">
            <Pagination {...pagination} navigateOnSelect />
          </div>
        </div>
      </div>
    </div>
  </Layout>
);
